import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { CheckboxField, DatePickerField, FormRow, TimeField } from '@frontend/design-system';
import { DEFAULT_TIME_FIELD_SCROLL_TO_TIME } from '../../../../constants';

type FieldPropsGetter = (...args: any[]) => Record<string, unknown>;
type DatePickerFieldProps = Omit<ComponentProps<typeof DatePickerField>, 'label'>;
type TimeFieldProps = Omit<ComponentProps<typeof TimeField>, 'label'>;

type Props<TFieldProps extends FieldPropsGetter> = {
  getFieldProps: TFieldProps;
  allDayFieldProps?: Omit<ComponentProps<typeof CheckboxField>, 'label'>;
};

export const NonRecurrenceFields = <TFieldProps extends FieldPropsGetter>({
  getFieldProps,
  allDayFieldProps,
}: Props<TFieldProps>) => {
  const { t } = useTranslation('schedule-settings');
  const isAllDay = allDayFieldProps?.value as boolean | undefined;

  return (
    <>
      <FormRow>
        <DatePickerField
          label={t('Start Date')}
          {...(getFieldProps('startDate') as DatePickerFieldProps)}
          hasNonFloatingLabel
        />
        <DatePickerField
          label={t('End Date')}
          {...(getFieldProps('endDate') as DatePickerFieldProps)}
          hasNonFloatingLabel
        />
      </FormRow>
      {allDayFieldProps && (
        <FormRow>
          <CheckboxField {...allDayFieldProps} label={t('All-Day')} />
        </FormRow>
      )}
      <FormRow>
        <TimeField
          label={t('Start Time')}
          {...(getFieldProps('startTime') as TimeFieldProps)}
          disabled={isAllDay}
          initialScrollTime={DEFAULT_TIME_FIELD_SCROLL_TO_TIME}
          hasNonFloatingLabel
        />
        <TimeField
          label={t('End Time')}
          {...(getFieldProps('endTime') as TimeFieldProps)}
          disabled={isAllDay}
          initialScrollTime={DEFAULT_TIME_FIELD_SCROLL_TO_TIME}
          hasNonFloatingLabel
        />
      </FormRow>
    </>
  );
};
